import { Ellipsis, TooltipTrigger } from "@visiblethread/react-components";
import EmptyDocumentIcon from "components/EmptyDocumentIcon";
import Flex, { GAP_CLASS } from "components/Flex";
import { getDocumentIcon } from "components/Modal/ChooseFilesModal/utils";
import {
  isDocumentWordless,
  WORDLESS_DOCUMENT_TOOLTIP,
} from "utils/reportSelectability";

import classes from "./ChooseShredDocumentModal.module.scss";

const sortByLoweredName = (a, b) => {
  const aName = (a.original.name ?? "").toLowerCase();
  const bName = (b.original.name ?? "").toLowerCase();
  if (aName < bName) {
    return -1;
  }
  if (aName > bName) {
    return 1;
  }
  return 0;
};

const LOCATION_TYPE_LABELS = {
  PROPOSAL: "Proposal",
  OPPORTUNITY: "Tracked Opp",
  CONTRACT: "Contract",
  MISC_ANALYSIS: "Misc Analysis",
};

const CURRENT_ENTITY_LABEL = {
  PROPOSAL: "This Proposal",
  OPPORTUNITY: "This Opportunity",
  CONTRACT: "This Contract",
  MISC_ANALYSIS: "This Analysis",
};

const getLocationType = (doc, proposalDocIds, entityType) =>
  proposalDocIds.has(doc.id)
    ? CURRENT_ENTITY_LABEL[entityType] || []
    : LOCATION_TYPE_LABELS[doc.origin] || "-";

export const buildColumns = ({
  proposalDocIds,
  showWorkspace,
  entityType = "PROPOSAL",
}) => {
  const nameColumn = {
    header: "Document Name",
    accessorKey: "name",
    id: "name",
    sortingFn: sortByLoweredName,
    size: showWorkspace ? 250 : 470,
    enableResizing: showWorkspace,
    minSize: 100,
    cell: ({ row }) => {
      const wordless = isDocumentWordless(row.original);
      return (
        <TooltipTrigger
          isEnabled={wordless}
          content={WORDLESS_DOCUMENT_TOOLTIP}
          classes={classes["choose_shred_doc__name_tooltip"]}
        >
          <Flex
            gap={GAP_CLASS.GAP_200}
            className={classes["choose_shred_doc__name_cell"]}
          >
            {getDocumentIcon(row.original.name, row.original.source)}
            <Ellipsis text={row.original.name} enableTooltip={!wordless} />
            {wordless && <EmptyDocumentIcon />}
          </Flex>
        </TooltipTrigger>
      );
    },
  };

  if (!showWorkspace) {
    return [nameColumn];
  }

  return [
    { ...nameColumn, enableSorting: false },
    {
      header: "Location Type",
      id: "locationType",
      size: 150,
      minSize: 100,
      enableSorting: false,
      cell: ({ row }) => (
        <span>{getLocationType(row.original, proposalDocIds, entityType)}</span>
      ),
      accessorFn: (row) => getLocationType(row, proposalDocIds, entityType),
    },
    {
      header: "Location",
      id: "originName",
      size: 220,
      minSize: 100,
      enableResizing: false,
      enableSorting: false,
      accessorFn: (row) => row.originName || "",
      cell: ({ row }) => <Ellipsis text={row.original.originName || "-"} />,
    },
  ];
};
